// @flow
import React from 'react';
import {
  Card, H2,
} from 'components';
import styles from './styles.module.scss';
import routes from '../../constants/routes';
import CustomLink from '../../components/CustomLink/Link';

const Congratulations = () => (
  <Card
    className={styles.containerForm}
    use="light"
    title={<H2 color="dark" className={styles.title}>Registration successful!</H2>}
  >
    <CustomLink name="Log in here" use="black" to={routes.auth.signIn.root} />
  </Card>
);

export default Congratulations;
